import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IServiceExceptionResponseModel } from '../../../models/index';
import { getServiceExceptionList } from '../../actions/actionType/services/ServiceActionTypes';
import { clearServiceExceptionList, getServiceExceptionListFailure, getServiceExceptionListStarted, getServiceExceptionListSuccess } from '../../actions/sagaActions/services/ServiceExceptionListSagaAction';

import { GetServiceExceptionListFailurePayload, GetServiceExceptionListRequest } from '../../actions/types/services/GetServiceExceptionListTypes';
import { headersInstance } from '../../../../common/utils/HeaderUtils';

/**
 * Call Gets service exception list by Service Name
 * @param serviceName : string
 * @returns api response
 */
export async function callGetServiceExceptionListApi(serviceName: string, status: string) {
  return apiWrapper.get<IServiceExceptionResponseModel[]>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/services/exceptions/serviceName/${serviceName}/status/${status}`,
    headersInstance()
  );
}

/**
 * Saga to get service Exception List by serviceName
 * @param serviceName:string
 */
export function* getServiceExceptionListByServiceName({ serviceName, status }: GetServiceExceptionListRequest) {
  yield put(clearServiceExceptionList());
  yield put(getServiceExceptionListStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetServiceExceptionListApi, serviceName, status);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(getServiceExceptionListSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: GetServiceExceptionListFailurePayload = {
      error: String(error)
    };
    yield put(getServiceExceptionListFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchServiceExceptionListDetailsSaga() {
  yield takeLatest(getServiceExceptionList.FETCH_SERVICE_EXCEPTION_LIST_REQUEST, getServiceExceptionListByServiceName);
}

export const getServiceExceptionListSaga = [fork(fetchServiceExceptionListDetailsSaga)];
